/* 7.11 track K3 (2026-09-29): cart page extras, loaded only by sections/main-cart.liquid.
   1. Receipt reprint: on the first two cart updates of a session the old receipt is torn off
      above the checkout block and thrown away, and the new one prints in under a paper cover.
      Watches <theme-cart> (cart.js is not edited): the theme adds .cart-disabled when an update
      starts (copy the receipt then) and swaps the cart's HTML when it arrives (play then).
      A failed update never swaps, so the copy is dropped. Nothing ever blocks a tap: the copy
      and the cover both let pointer events through.
   2. After every update, focus goes back where it was (or to the next item after a remove);
      a size/colour swap that moves the item flashes its track number.
   3. Static CD pile (reduced motion / no physics; Round 3's gravity lives in jk-cart-cds.js): a case
      toggles its disc; one disc out at a time; kept out across updates.
   4. Barcode: shares (touch) or copies a link that rebuilds this cart on /cart.
   5. REMOVE works with Enter and Space. */
(function () {
	var cart = document.querySelector('.jk-cart theme-cart');
	if (!cart) return;
	var root = cart.parentNode, KEY = 'jkReprints', mem = 0, ghost = null, playing = null, running = null, back = null;
	var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
	function get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
	function put(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
	function used() { return Math.max(mem, +get(KEY) || 0); }
	function bump() { mem = used() + 1; put(KEY, mem); }
	function rows() { return cart.querySelectorAll('tbody tr'); }

	// A new update while a reprint still plays: finish it at once (motion never blocks input).
	function settle() { if (running) { clearTimeout(running.t); running.done(); running = null; } }

	function copyReceipt() {
		settle();
		var box = cart.querySelector('.jk-cart__box--cart');
		if (!box || calm.matches || used() >= 2) return null;
		var r = box.getBoundingClientRect(), o = root.getBoundingClientRect();
		var c = box.cloneNode(true);
		// Torn off above the checkout block: only the head, the items and the subtotal fly.
		c.querySelectorAll('.jk-cart__checkout > :not(.jk-cart__totals), script, iframe').forEach(function (e) { e.remove(); });
		c.querySelectorAll('[id], [name]').forEach(function (e) { e.removeAttribute('id'); e.removeAttribute('name'); });
		c.querySelectorAll('.loading').forEach(function (e) { e.classList.remove('loading'); });
		// Custom elements would boot again inside the copy: swap them for plain divs.
		c.querySelectorAll('*').forEach(function (e) {
			if (e.localName.indexOf('-') < 0) return;
			var d = document.createElement('div');
			d.className = e.className;
			d.append.apply(d, e.childNodes);
			e.replaceWith(d);
		});
		c.classList.add('jk-toss');
		c.setAttribute('aria-hidden', 'true');
		c.inert = true;
		c.style.cssText = 'left:' + (r.left - o.left) + 'px;top:' + (r.top - o.top) + 'px;width:' + r.width + 'px';
		return c;
	}

	function reprint() {
		var g = ghost;
		ghost = null;
		if (!g) return;
		bump();
		var fx = root.querySelector('.jk-cart__fx');
		if (!fx) { fx = document.createElement('div'); fx.className = 'jk-cart__fx'; root.appendChild(fx); }
		fx.appendChild(g);
		// The live receipt is in place and clickable at once; a paper cover (pointer-events: none)
		// over the items and subtotal recedes in printer steps once the torn slip has cleared.
		var box = cart.querySelector('.jk-cart__box--cart, .jk-cart__box--empty'), cover = null;
		if (box) {
			var end = box.querySelector('.jk-cart__totals');
			cover = document.createElement('div');
			cover.className = 'jk-cover';
			cover.setAttribute('aria-hidden', 'true');
			cover.style.height = Math.round((end || box).getBoundingClientRect().bottom - box.getBoundingClientRect().top) + 'px';
			box.appendChild(cover);
		}
		running = { done: function () { g.remove(); if (cover) cover.remove(); } };
		running.t = setTimeout(settle, 460);
	}

	// Remember where the shopper was when an update starts ...
	function mark() {
		var a = document.activeElement;
		if (!a || a === document.body || !cart.contains(a)) { back = null; return; }
		var tr = a.closest('tr'), link = tr && tr.querySelector('.cart-product-link');
		back = {
			label: a.getAttribute('aria-label'),
			row: tr ? [].indexOf.call(rows(), tr) : -1,
			swap: a.matches('.cart-item-size') && link ? link.getAttribute('title') : null
		};
	}
	// ... and put them back there when the new cart lands.
	function restore() {
		var b = back;
		back = null;
		if (!b) return;
		var list = rows(), el = null, moved = null;
		if (b.swap) {
			[].some.call(list, function (tr, i) {
				var l = tr.querySelector('.cart-product-link');
				if (l && l.getAttribute('title') === b.swap) { moved = i !== b.row ? tr : null; return true; }
				return false;
			});
		}
		if (b.label) el = cart.querySelector('[aria-label="' + (window.CSS && CSS.escape ? CSS.escape(b.label) : b.label) + '"]');
		if (!el && list.length && b.row > -1) el = list[Math.min(b.row, list.length - 1)].querySelector('.cart-product-link');
		if (!el) { el = cart.querySelector('.jk-cart__title, .cart-empty h1'); if (el) el.tabIndex = -1; }
		if (el && (document.activeElement === document.body || !document.activeElement)) el.focus({ preventScroll: true });
		if (moved) {
			moved.scrollIntoView({ block: 'nearest' });
			if (!calm.matches) {
				var n = moved.querySelector('.jk-cart__trk');
				if (n) { n.classList.add('jk-cart__trk--moved'); setTimeout(function () { n.classList.remove('jk-cart__trk--moved'); }, 600); }
			}
		}
	}

	// The static pile (reduced motion, or no physics): its disc spins only while the pile is on screen.
	var seen = window.IntersectionObserver && new IntersectionObserver(function (es) {
		es.forEach(function (e) { e.target.classList.toggle('jk-pile--off', !e.isIntersecting); });
	});
	function watchPile() { var p = cart.querySelector('.jk-pile'); if (seen) { seen.disconnect(); if (p) seen.observe(p); } }
	watchPile();

	new MutationObserver(function (recs) {
		var swapped = recs.some(function (r) { return r.type === 'childList'; });
		var busy = cart.classList.contains('cart-disabled');
		if (swapped) {
			reprint();
			watchPile();
			restore();
			var cd = playing && cart.querySelector('.jk-cd[data-cd="' + playing + '"]');
			if (cd) { cd.classList.add('jk-cd--now'); cd.setAttribute('aria-pressed', 'true'); } else playing = null;
		} else if (busy) {
			if (!ghost) ghost = copyReceipt();
			if (!back) mark();
		} else {
			ghost = null;
			back = null;
		}
	}).observe(cart, { childList: true, attributes: true, attributeFilter: ['class'] });

	function share(b) {
		var url = b.getAttribute('data-jk-share'), msg = b.querySelector('.jk-cart__catno');
		var say = function (t) {
			msg.dataset.t = msg.dataset.t || msg.textContent;
			msg.textContent = t;
			clearTimeout(b.jkT);
			b.jkT = setTimeout(function () { msg.textContent = msg.dataset.t; }, 3000);
		};
		// Copying refused: show the link itself, selected, to copy by hand.
		var show = function () {
			var i = b.parentNode.querySelector('.jk-cart__link');
			if (!i) { i = document.createElement('input'); i.className = 'jk-cart__link'; i.readOnly = true; i.setAttribute('aria-label', 'Link to this cart'); b.parentNode.appendChild(i); }
			i.value = url;
			i.focus();
			i.select();
		};
		if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
			navigator.share({ title: 'Jackler cart', url: url }).catch(function () {});
		} else if (navigator.clipboard && navigator.clipboard.writeText) {
			navigator.clipboard.writeText(url).then(function () { say('Link copied'); }, show);
		} else {
			show();
		}
	}

	cart.addEventListener('click', function (e) {
		var cd = e.target.closest('.jk-cd');
		if (cd) {
			var on = cd.getAttribute('aria-pressed') !== 'true';
			cart.querySelectorAll('.jk-cd').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); x.classList.remove('jk-cd--now'); });
			cd.setAttribute('aria-pressed', on ? 'true' : 'false');
			playing = on ? cd.getAttribute('data-cd') : null;
			return;
		}
		var b = e.target.closest('.jk-cart__share');
		if (b) share(b);
	});

	// A size/colour swap disables every select before the cart goes busy (focus drops to the
	// page), so note the shopper's place as the change happens.
	cart.addEventListener('change', function (e) { if (e.target.matches('.cart-item-size')) mark(); }, true);

	cart.addEventListener('keydown', function (e) {
		if (e.target.localName === 'cart-remove' && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); e.target.click(); }
	});
})();
